import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/lib/theme-chalk/index.css";
// import zhLocal from "element-plus/lib/locale/lang/zh-cn"

// export const __URL__ = 'http://ky2.dev.com:8085/admin'
export const __URL__ = "https://old.xyxmf.cn/admin";
// export const __URL__ = "http://www.siji.com/admin";

// export const __URL__ = 'https://jk.ooweixin.cn/admin'
// export const __URL__ = 'http://cc.sxqhkj.com/admin'
// createApp(App).use(store).use(router).use(ElementPlus,{locale:zhLocal}).mount('#app')
createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .mount("#app");
